import { SelectPicker } from '../../Mobiscroll-select.component'
import { getFieldTestId } from '../field-helpers'
import type { FieldRenderer } from '../types'

const renderSelectField: FieldRenderer = ({ field, ctx, t }) => {
    const key = field.key
    return (
        <SelectPicker
            key={key}
            label={t(field.label)}
            value={ctx.form[key] as string}
            data={(ctx.regions ?? []).map(r => ({ text: r.name, value: r.id }))}
            onChange={val => ctx.setForm((prev: Record<string, unknown>) => ({ ...prev, [key]: val }))}
            disabled={ctx.formDisabled || ctx.geoLoading || ctx.regionsLoading}
            inputTestId={getFieldTestId(ctx, key, 'input')}
            optionTestIdPrefix={getFieldTestId(ctx, key, 'list')}
            data-testid={getFieldTestId(ctx, key, 'select-picker')}
        />
    )
}

renderSelectField.areCtxEqual = (a, b) => a.regions === b.regions && a.regionsLoading === b.regionsLoading && a.geoLoading === b.geoLoading

export default renderSelectField
